export default __webpack_public_path__ + "static/logo-como-investir-c4b479bf803ec8a16fd3cf621f550821.png";